import React from "react";
import Aplicativo from "assets/cards/aplicativo.svg";
import Prescricao from "assets/cards/prescricao.svg";
import Prontuario from "assets/cards/prontuario-inteligente.svg";
import Telemedicina from "assets/cards/telemedicina.svg";
import { SectionInfo } from "components/card/SectionCard";
import { appPrestadorStoreLink, sendAnalyticEvent } from "utils/store-link";

export const HomeCards = () => {
  const LINK_TO_REGISTER = appPrestadorStoreLink();

  return (
    <div className="container">
      <SectionInfo
        alignContentLeftItem={
          "d-flex justify-content-center justify-content-md-end"
        }
        leftComponent={
          <img
            className="img-fluid"
            style={{ height: "250px" }}
            src={Telemedicina}
            alt=""
          />
        }
        rightComponent={
          <div>
            <h1 className="title text-center text-md-left text-primary section-card__title section-card__title-large my-2">
              Telemedicina
            </h1>
            <h2 className="subtitle text-center text-md-left">
              Praticidade e segurança integrada ao Prontuário Digital: atenda
              seus pacientes do computador, Tablet ou App (IOS e Android)
            </h2>
            <div className="text-center text-md-left my-2">
              <a
                href={LINK_TO_REGISTER}
                onClick={() => sendAnalyticEvent()}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-primary rounded-pill mb-3"
                style={{ width: "220px" }}
              >
                Conheça o ProntLife
              </a>
            </div>
          </div>
        }
      />
      <SectionInfo
        reverse={true}
        alignContentLeftItem={
          "d-flex justify-content-center justify-content-md-start"
        }
        leftComponent={
          <img
            className="image align-self-start"
            src={Prescricao}
            alt=""
            style={{ height: "250px" }}
          />
        }
        rightComponent={
          <div>
            <h1 className="title text-center text-md-left text-primary section-card__title my-2">
              Prescrição com Certificação Digital
            </h1>
            <h2 className="subtitle text-center text-md-left">
              Assine digitalmente a Prescrição de medicamentos e envie aos seus
              pacientes por e-mail, seguindo padrões do CFM (ICP Brasil).
            </h2>
          </div>
        }
      />
      <SectionInfo
        leftComponent={
          <img
            className="image align-self-start"
            src={Prontuario}
            alt=""
            style={{ height: "250px" }}
          />
        }
        alignContentLeftItem={
          "d-flex justify-content-center justify-content-md-end"
        }
        rightComponent={
          <div>
            <h1 className="title text-center text-md-left text-primary section-card__title my-2">
              Prontuário Eletrônico Inteligente
            </h1>
            <h2 className="subtitle text-center text-md-left">
              Customizado para diversas especialidades, crie seus protocolos de
              exames e tratamentos, com dados clínicos e de medicamentos
              padronizados (CID-10, CIAP2, TUSS, Anvisa)
            </h2>
            <div className="text-center text-md-left my-2">
              <a
                href={LINK_TO_REGISTER}
                onClick={() => sendAnalyticEvent()}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-primary rounded-pill mb-3"
                style={{ width: "220px" }}
              >
                Tenha o seu prontuário
              </a>
            </div>
          </div>
        }
      />

      <SectionInfo
        reverse={true}
        alignContentLeftItem={
          "d-flex justify-content-center justify-content-md-start"
        }
        leftComponent={
          <img
            className="image align-self-start"
            src={Aplicativo}
            alt=""
            style={{ height: "250px" }}
          />
        }
        rightComponent={
          <div>
            <h1 className="title text-center text-md-left text-primary section-card__title my-2">
              App ProntLife Médico (IOS e Android)
            </h1>
            <h2 className="subtitle text-center text-md-left">
              Sua clínica em suas mãos: acesse o prontuário dos pacientes,
              realize consultas presenciais e Teleconsultas, faça prescrições
              digitais e compartilhe com seus pacientes por SMS, E-mail ou
              WhatsApp
            </h2>
          </div>
        }
      />
    </div>
  );
};
